module.exports = __webpack_public_path__ + "img/DocBnrRush.6f1f2ffe.gif";